import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import SweetAlert from "react-bootstrap-sweetalert";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faArrowLeft,
  faCog,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import Container from "../../components/Container";
import Footer from "../../components/Footer";

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem("Authorization"),
      id: "",
      oldname: "",
      fullname: "",
      institusi: "",
      email: "",
      phone: "",
      oldpass: "",
      newpass: "",
      isReady: 0,
      disabled: false,
      alert: null,
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/customer/whois`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          var progress = this.state.isReady + 100;
          this.setState({
            id: response.data.user.id,
            oldname: response.data.user.fullname,
            fullname: response.data.user.fullname,
            institusi: response.data.user.institusi,
            email: response.data.user.email,
            phone: response.data.user.phone,
            isReady: progress,
          });
        } else {
          this.props.history.push("/login");
        }
      });
  }

  handleFieldChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      disabled: true,
    });
    const formData = new FormData();
    formData.append("id", this.state.id);
    formData.append("fullname", this.state.fullname);
    formData.append("institusi", this.state.institusi);
    formData.append("email", this.state.email);
    formData.append("phone", this.state.phone);

    axios
      .post(`${window.localhost}/customer/update`, formData, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((res) => {
        if (res.data.success === true) {
          this.showAlert("Info Pengguna berhasil disimpan!");
          this.setState({
            disabled: false,
          });
        }
      });
  }

  showAlert(message) {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
        confirmBtnBsStyle="warning"
      >
        {message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.componentDidMount();
    this.hideAlert();
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    if (this.state.isReady < 100) {
      return <LoadingScreen />;
    } else {
      const navmenu = () => {
        return (
          <div className="dropdown">
            <button
              className="btn text-danger d-flex align-items-center dropdown-toggle"
              aria-current="page"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="me-2 d-md-flex d-none">
                {this.state.oldname}
              </span>
              <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <a className="dropdown-item" href="/info-pengguna">
                  <FontAwesomeIcon icon={faUserCog} /> Info Pengguna
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button className="dropdown-item" onClick={this.confirmLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                </button>
              </li>
            </ul>
          </div>
        );
      };
      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Info Pengguna - Creatifa Brief App</title>
            <meta
              name="description"
              content="Brief ini untuk membantu kami dalam membuat desain logo Anda. Mohon luangkan waktu untuk mengisi dengan jawaban se-objektif mungkin. Semakin Anda menuliskan gambaran usaha Anda dengan jelas, semakin kami dapat memahami desain logo seperti apa yang Anda butuhkan"
            />
          </Helmet>
          <Header menu={navmenu()} destination={`/`} />
          <Container>
            <div className="row mt-3">
              <div className="card">
                <div className="card-body">
                  <h3 className="card-title">Info Pengguna</h3>
                  <hr />
                  <form onSubmit={this.handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Nama Lengkap
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        name={`fullname`}
                        type="text"
                        id={`fullname`}
                        aria-describedby={`nama lengkap`}
                        className={`form-control form-cream border-0`}
                        autoComplete="off"
                        onChange={this.handleFieldChange}
                        disabled={this.state.disabled}
                        value={this.state.fullname}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Institusi
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        name={`institusi`}
                        type="text"
                        id={`institusi`}
                        aria-describedby={`institusi`}
                        className={`form-control form-cream border-0`}
                        autoComplete="off"
                        onChange={this.handleFieldChange}
                        disabled={this.state.disabled}
                        value={this.state.institusi}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Email
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        name={`email`}
                        type="email"
                        id={`email`}
                        aria-describedby={`email`}
                        className={`form-control form-cream border-0`}
                        autoComplete="off"
                        onChange={this.handleFieldChange}
                        disabled={this.state.disabled}
                        value={this.state.email}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Phone
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        name={`phone`}
                        type="text"
                        id={`phone`}
                        aria-describedby={`phone`}
                        className={`form-control form-cream border-0`}
                        autoComplete="off"
                        onChange={this.handleFieldChange}
                        disabled={this.state.disabled}
                        value={this.state.phone}
                        required
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <Link to={`/`} className="btn btn-secondary px-4">
                        Kembali
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-red text-light px-4"
                      >
                        <span
                          className={`spinner-border spinner-border-sm ${
                            this.state.disabled ? " " : "d-none"
                          }`}
                          role="status"
                          aria-hidden="true"
                        ></span>{" "}
                        Simpan
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Container>
          {this.state.alert}
          <Footer />
        </div>
      );
    }
  }
}

export default EditUser;
